import type { NextRouter } from 'next/router';
import { useRouter } from 'next/router';

function getLayoutPathnames(pathname: string) {
  const isMembersCheckout = pathname.startsWith('/members/checkout');

  return {
    isCheckout: pathname.startsWith('/checkout'),
    isMembers: pathname.startsWith('/members') || isMembersCheckout,
    isMembersCheckout,
    isMembersSubscriptionList: pathname.startsWith('/members/subscriptions')
  };
}

export function useLayoutPathname() {
  const router = useRouter();
  return getLayoutPathnames(router.pathname);
}

export function getLayoutPathnameFromRouter(router: NextRouter) {
  return getLayoutPathnames(router.pathname);
}
